import * as React from 'react';
import {
  Card, CardContent, Box, Typography, Paper, IconButton, Menu, MenuItem, Grid, Button,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import type { GridColumns } from '@material-ui/data-grid';
import {
  DataGrid,
} from '@material-ui/data-grid';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import globalUseStyles from '../../globalClasses';
import { colors } from '../../theme';
import type { ISkillLevelType } from './SkillLevelTypeInterfaces';

const useStyles = makeStyles(() => createStyles({
  textBlue: {
    color: colors.primary,
  },
}));

interface SkillLevelTypeLookupProps {
  data: ISkillLevelType[] | undefined,
  addNewType: () => void;
  setSkillLevelTypeFormValues: (value: ISkillLevelType) => void,
  setSkillLevelUnEditedValues: (value: ISkillLevelType) => void,
  setShowTypesModal: (value: boolean) => void,
  setInterfaceType: React.Dispatch<React.SetStateAction<string>>;
  deleteSillLevelType: () => void,
}

const SkillLevelTypeLookup: React.FC<SkillLevelTypeLookupProps> = ({
  data, addNewType, setSkillLevelTypeFormValues, setSkillLevelUnEditedValues, setShowTypesModal, setInterfaceType, deleteSillLevelType,
}) => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [pageSize, setPageSize] = React.useState(10);

  const handleVertIconClick = (event: React.MouseEvent<HTMLButtonElement>, value: number) => {
    if (!anchorEl) {
      setAnchorEl(event.currentTarget);
      if (data?.filter((slt) => slt.value === value)[0]) {
        setSkillLevelTypeFormValues(data?.filter((slt) => slt.value === value)[0]);
        setSkillLevelUnEditedValues(data?.filter((slt) => slt.value === value)[0]);
      }
    }
  };

  const tableColumns: GridColumns = [
    {
      field: 'name',
      headerName: 'Skill Level Type',
      flex: 0.5,
      align: 'left',
    },
    {
      field: 'level',
      headerName: 'Level',
      flex: 0.3,
    },
    {
      field: 'group',
      headerName: 'Skill Level Group',
      flex: 0.5,
    },
    {
      field: 'value',
      headerName: 'Actions',
      flex: 0.25,
      renderCell: ({ value }) => (
        ((typeof (value) === 'number')
          ? (
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleVertIconClick(event, value)}
            >
              <MoreVertIcon />
            </IconButton>
          )
          : <></>
        )
      ),
    },
  ];

  const tableRows = data && data?.map((slt, index) => ({
    value: slt.value || index,
    name: slt.name || '',
    level: slt.level || '',
    group: slt.group || '',
    id: slt.value,
  }));

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditSkillLevelType = () => {
    setShowTypesModal(true);
  };

  return (
    <Paper>
      <Card>
        <Grid item xs={12}>
          <Box p={2}>
            <Grid container spacing={0}>
              <Grid item xs={8}>
                <Typography variant="h6" className={classes.textBlue} display="inline">{'Skill Level Types'}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Button fullWidth variant="contained" color="primary" onClick={() => addNewType()}>
                  { 'Add Skill Level Type' }
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <CardContent>
            <Box height={((pageSize + 1) * 52) + 60}>
              <DataGrid
                rows={tableRows || []}
                columns={tableColumns}
                pageSize={pageSize}
                rowsPerPageOptions={[10, 25, 50, 100]}
                loading={!data}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                className={globalStyles.transparentDataGrid}
              />
            </Box>
            {anchorEl
            && (
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              >
                <MenuItem id="edit-skillLevelType-button" onClick={() => { handleEditSkillLevelType(); handleCloseMenu(); setInterfaceType('Edit'); }}>{'Edit'}</MenuItem>
                <MenuItem id="delete-skillLevelType-button" onClick={() => { deleteSillLevelType(); handleCloseMenu(); }}>{'Delete'}</MenuItem>
              </Menu>
            )}
          </CardContent>
        </Grid>
      </Card>
    </Paper>
  );
};

export default SkillLevelTypeLookup;
